import { EProjectSection, trackEventV2 } from '../trackEventV2';
import { EReferralEventName, IReferralCodeShared, IReferralContactsImported } from './types';

export const trackReferralCodeSharedEvent = (event: IReferralCodeShared) => {
  trackEventV2(EReferralEventName.REFERRAL_CODE_SHARED, EProjectSection.MARKETPLACE, {
    ...event,
  });
};

export const trackReferralContactsImportedEvent = (event: IReferralContactsImported) => {
  trackEventV2(EReferralEventName.REFERRAL_CONTACTS_IMPORTED, EProjectSection.MARKETPLACE, {
    ...event,
  });
};
